import type { SxProps, Theme } from '@mui/material';

export const sxWrapper: SxProps<Theme> = {
  pb: 12,
};

export const sxContent: SxProps<Theme> = {
  px: 4,
};
